import { ReasonRejectionComment } from "@interfaces/slices";
import { Box, Stack, Typography } from "@mui/material";

export const ComentarioMotivoRechazo = (props: ReasonRejectionComment) => {
    return (
        <Box
            sx={{
                ml: 4,
                mr: 4,
                mt: 4,
                mb: 3,
                maxWidth: "300px"
            }}>
            <Stack
                sx={{
                    textAlign: "center",
                    rowGap: 2
                }}>
                <Typography variant="body1" sx={{
                    color: "main3",
                    fontWeight: 600
                }}>
                    Motivo de rechazo
                </Typography>
                <Typography>{props.text.split("|").at(1)}</Typography>
            </Stack>
        </Box>
    );
};
